import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import { Amplify } from 'aws-amplify';
import aws_exports from './aws-exports';

import AmplifyVue from '@aws-amplify/ui-vue';
import "@aws-amplify/ui-vue/styles.css";

import {
  applyPolyfills,
  defineCustomElements,
} from '@aws-amplify/ui-components/loader';

import { I18n } from 'aws-amplify';
import { translations } from '@aws-amplify/ui-vue';
I18n.putVocabularies(translations);
I18n.setLanguage('ja');

let languageDict = {
  ja:{
      'Sign In Account' : 'アカウントにサインイン',
      'Username' : 'ユーザ名',
      'Username *': 'ユーザ名 *',
      'Enter your username' : 'ユーザ名を入力してください',
      'Password' : 'パスワード',
      'Enter your password' : 'パスワードを入力してください',
      'Forget your password? ' : 'パスワードを忘れた場合',
      'Reset password' : 'パスワードのリセット',
      'No account? ' : 'まだアカウントがない場合',
      'Create account' : 'アカウント作成',
      'Sign In' : 'サインイン',
  }
}
I18n.putVocabularies(languageDict);

Amplify.configure(aws_exports);
  applyPolyfills().then(() => {
    defineCustomElements(window);
  });
createApp(App).use(AmplifyVue).use(router).mount('#app')
